import { render, staticRenderFns } from "./top-suppliers.vue?vue&type=template&id=7c24aedc&"
import script from "./top-suppliers.vue?vue&type=script&lang=ts&"
export * from "./top-suppliers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports